import { Component, OnDestroy, OnInit } from '@angular/core';
import { DateTime } from 'luxon';
import { AppointmentService } from '../../../shared/services/appointment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SubscriptionList } from '../../../shared/models/asp.types';
import { unsubscribeSubscriptions } from '../../../shared/services/util.service';
import { AppointmentType, IResponse, IPartsAppointment } from '@signal/asp-data-commons';
import { AspBannerService } from '../../../shared/services/asp-banner.service';
import * as util from '../../../shared/services/util.service'

@Component({
  selector: 'app-confirm-info-parts',
  templateUrl: './confirm-info.component.html',
  styleUrls: ['./confirm-info.component.scss']
})
export class ConfirmInfoComponentParts implements OnInit, OnDestroy {
  view = 'confirm';
  appointment!: IPartsAppointment;
  makeModelYear!: string;
  detailMap!: { [key: string]: string };
  id!: string;
  subscriptions: SubscriptionList = {};

  constructor(
    private readonly appointmentService: AppointmentService,
    private readonly route: ActivatedRoute,
    private bannerService: AspBannerService,
    private readonly router: Router
  ) {

    const urlState = this.router?.getCurrentNavigation()?.extras?.state as IPartsAppointment;

    if (urlState?.appointmentId) {
      this.appointment = urlState;
      this.setDetailMap(urlState);
    } else {
      this.subscriptions.query = this.route.queryParams.subscribe(params => {
        this.id = params.id;
        if (this.id) {
          this.subscriptions.getAppt = this.appointmentService.get(AppointmentType.PARTS, this.id).subscribe((res: IResponse<IPartsAppointment>) => {
            if (res && res.data) {
              this.appointment = res.data;
              this.setDetailMap(res.data);
            }
          });
        }
      });
    }
  }

  ngOnInit(): void {
    this.bannerService.hide();
  }

  setDetailMap(appointmentDetails: any) {
    const date = `${DateTime.fromISO(appointmentDetails.appointmentStartDate).toFormat('MMMM dd')}`;
    const time = appointmentDetails.timeSlotId;

    const dateTime = `${date} at ${time}`;

    const vehicle = appointmentDetails.vehicle;
    const commentsFromDealer = appointmentDetails.appointmentComments ? this.getComment(appointmentDetails.appointmentComments, 'Comments-From-Dealer') : '';
    const dealerInternalComment = appointmentDetails.appointmentComments ? this.getComment(appointmentDetails.appointmentComments, 'Dealer-Internal-Comments') : '';
    const additionalComments = appointmentDetails.appointmentComments ? this.getComment(appointmentDetails.appointmentComments, 'Customer-Additional-Comments') : '';

    const makeModelYearText = `${vehicle.year || ''} ${util.titleCase(vehicle.make) || ''} ${vehicle.model || ''}`.trim();
    if (makeModelYearText && vehicle?.vin?.length) {
      this.makeModelYear = `${makeModelYearText}\nVIN ${vehicle.vin}`;
    } else if (vehicle?.vin?.length && (vehicle?.make?.toLocaleLowerCase() === 'other' || !vehicle?.make?.length)) {
      this.makeModelYear = `VIN ${vehicle.vin}`;
    } else {
      this.makeModelYear = makeModelYearText;
    }
    const dealershipAddress = `${appointmentDetails.dealer.addressShort}`;

    this.detailMap = {
      'service.time': dateTime,
      'testDrive.vehicle': this.makeModelYear.trim() || '-NA-',
      'parts.orderRef': appointmentDetails.vehicle?.orderRefNumber || '-NA-',
      'parts.dealerOrder': appointmentDetails.vehicle?.dealerOrderNumber || '-NA-',
      'delivery.commentsFromDealer': commentsFromDealer,
      'delivery.internalDealerComments': dealerInternalComment,
      'delivery.customerComments': additionalComments,
      'Location': dealershipAddress
    };
    if (!commentsFromDealer) {
      delete this.detailMap['delivery.commentsFromDealer']
    }
    if (!dealerInternalComment) {
      delete this.detailMap['delivery.internalDealerComments']
    }
    if (!additionalComments) {
      delete this.detailMap['delivery.customerComments']
    }
  }

  getComment(data: string, field: string) {
    let returnComment = '';
    data.split(':::').forEach(comment => {
      if (comment.includes(field)) {
        returnComment = comment.replace(`${field} - `, '').trim();
      }
    })
    return returnComment;
  }

  ngOnDestroy(): void {
    unsubscribeSubscriptions(this.subscriptions);
  }

}